"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visibilityChangeEvent = exports.hasTouchEvents = exports.documentHidden = void 0;
var hasTouchEvents = ('ontouchstart' in window);
exports.hasTouchEvents = hasTouchEvents;
var hidden, visibilityChange;

if (typeof document.hidden !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}

var visibilityChangeEvent = visibilityChange;
exports.visibilityChangeEvent = visibilityChangeEvent;

var documentHidden = function documentHidden() {
  return document[hidden];
};

exports.documentHidden = documentHidden;